import React, { ReactNode, CSSProperties } from "react";
import { Theme, useMediaQuery } from "@mui/material";

const itemContainerStyle: CSSProperties = {
  display: "flex",
};

const titleContainerStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

const legendCircleContainerStyle: CSSProperties = {
  height: "12px",
  width: "12px",
  marginRight: "5px",
};

interface Props {
  beforeComponent?: ReactNode;
  color?: string;
  title: string;
  subtitle?: ReactNode;
  isStrong?: boolean;
  theme: Theme;
}

const LegendCircle = ({
  color,
  isStrong,
}: {
  color?: string;
  isStrong: boolean;
}) => {
  return (
    <div
      style={{
        ...legendCircleContainerStyle,
        marginTop: isStrong ? "12px" : "3px",
      }}
    >
      <div
        style={{
          display: "inline-block",
          boxSizing: "unset",
          width: isStrong ? "12px" : "10px",
          height: isStrong ? "12px" : "10px",
          borderRadius: "50%",
          backgroundColor: color ? color : "black",
        }}
      />
    </div>
  );
};

export const Item = ({
  color,
  title,
  subtitle,
  theme,
  isStrong = false,
  beforeComponent = <LegendCircle color={color} isStrong={isStrong} />,
}: Props) => {
  const isDownMd = useMediaQuery(theme.breakpoints.down("md"));

  const titleFontSize = isDownMd
    ? isStrong
      ? "26px"
      : "16px"
    : isStrong
      ? "32px"
      : "16px";
  const titleLineHeight = isDownMd
    ? isStrong
      ? "34px"
      : "24px"
    : isStrong
      ? "40px"
      : "24px";

  return (
    <div style={itemContainerStyle}>
      {beforeComponent}
      <div style={titleContainerStyle}>
        <p
          style={{
            color: theme.palette.text.onTooltipPrimary,
            fontFamily: theme.typography.fontFamily,
            fontWeight: isStrong ? 700 : 400,
            fontSize: titleFontSize,
            lineHeight: titleLineHeight,
            margin: 0,
          }}
        >
          {title}
        </p>
        <div
          style={{
            color: theme.palette.text.onTooltipPrimarySub,
            fontFamily: theme.typography.fontFamily,
            fontSize: "11px",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: "110px",
            whiteSpace: "nowrap",
            margin: "0",
          }}
        >
          {subtitle}
        </div>
      </div>
    </div>
  );
};
